import { keccak256, pad, parseEther, parseUnits, toHex, } from 'viem';
import { getUSDCAddress } from '../../../utils/getUSDCAddress';
export function getStateOverrides(args) {
    const { accountAddress, chain } = args;
    if (!chain) {
        throw new Error('Chain is required');
    }
    const usdcAddress = getUSDCAddress(chain);
    const balanceSlot = getUSDCBalanceSlot(accountAddress);
    return {
        [accountAddress]: {
            balance: toHex(parseEther('1000000')),
        },
        [usdcAddress]: {
            stateDiff: {
                [balanceSlot]: pad(toHex(parseUnits('1000000', 6)), { size: 32 }),
            },
        },
    };
}
const USDC_BALANCE_SLOT = 9n; // confirmed on base sepolia only
function getUSDCBalanceSlot(userAddress) {
    // Circle's formula: pad both address and slot to 32 bytes, then hash
    const paddedAddr = userAddress.toLowerCase().replace('0x', '').padStart(64, '0');
    const paddedSlot = USDC_BALANCE_SLOT.toString(16).padStart(64, '0');
    return keccak256(('0x' + paddedAddr + paddedSlot));
}
